import React from "react"
import { DataContextProvider } from "./crossfilter-context"
import CrossfilterTestChart from "./test"

export default () => {
  return (
    <DataContextProvider>
      <CrossfilterTestChart />
    </DataContextProvider>
  )
}
